// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /notification-settings/get-quiet-hours.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeNotificationSettingsGetQuietHoursBody,
  typeNotificationSettingsGetQuietHoursOutput200,
} from "../../sdk/notificationSettings/postNotificationSettingsGetQuietHours";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildNotificationSettingsGetQuietHoursQueryKey(
  payload: typeNotificationSettingsGetQuietHoursBody,
): string[] {
  const queryKeySegments: string[] = [];

  return [
    "post:notificationSettings:notificationSettingsGetQuietHours",
    "svc:notification-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeNotificationSettingsGetQuietHoursOutput200,
    unknown,
    typeNotificationSettingsGetQuietHoursOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useNotificationSettingsGetQuietHours(
  payload: typeNotificationSettingsGetQuietHoursBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildNotificationSettingsGetQuietHoursQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postNotificationSettingsGetQuietHours(payload),
    ...resolvedOptions,
  });
}
